export default __webpack_public_path__ + "static/media/waterfalls.a12bb6124dd35a72f6e26cc30e46852a.svg";